export default __webpack_public_path__ + "static/media/circle-profile.36829f13.png";